// ── THEMES ────────────────────────────────────────────────────────────────────
export const THEMES = [
  {
    id: 'violet',
    name: 'Gold',
    description: 'Warm amber and gold on deep charcoal — the signature look',
    preview: '#C9A84C',
    vars: {
      '--p':        '#C9A84C',
      '--p2':       '#A8893A',
      '--pink':     '#E8C97A',
      '--p-light':  '#FAF5E8',
      '--p-mid':    '#EFE0B0',
      '--p-dark':   '#7A5C1E',
      '--bg':       '#F7F4EF',
      '--surface':  '#FDFAF5',
      '--surface2': '#F2EDE3',
      '--border':   '#E4DDD0',
      '--border2':  '#CFC6B4',
      '--text':     '#1A1612',
      '--text2':    '#5C5044',
      '--text3':    '#9B8E7E',
      '--sidebar-from': '#1A1612',
      '--sidebar-to':   '#0F0C09',
      '--login-from':   '#F7F4EF',
      '--login-mid':    '#EFE8DA',
      '--login-to':     '#F7F4EF',
    },
  },
  {
    id: 'rose',
    name: 'Rose',
    description: 'Soft pinks with warm blush tones',
    preview: '#F472B6',
    vars: {
      '--p':        '#F472B6',
      '--p2':       '#EC4899',
      '--pink':     '#FDA4AF',
      '--p-light':  '#FDF2F8',
      '--p-mid':    '#FBCFE8',
      '--p-dark':   '#BE185D',
      '--bg':       '#FFF5F8',
      '--surface':  '#FFFFFF',
      '--surface2': '#FFF0F5',
      '--border':   '#FCE7F3',
      '--border2':  '#F9A8D4',
      '--text':     '#4A0E2C',
      '--text2':    '#9D3464',
      '--text3':    '#C86E96',
      '--sidebar-from': '#4A0E2C',
      '--sidebar-to':   '#2D0A1A',
      '--login-from':   '#FFF0F5',
      '--login-mid':    '#FBCFE8',
      '--login-to':     '#FFF5F8',
    },
  },
  {
    id: 'ocean',
    name: 'Ocean',
    description: 'Cool teals with deep blue accents',
    preview: '#22D3EE',
    vars: {
      '--p':        '#22D3EE',
      '--p2':       '#06B6D4',
      '--pink':     '#67E8F9',
      '--p-light':  '#ECFEFF',
      '--p-mid':    '#CFFAFE',
      '--p-dark':   '#0E7490',
      '--bg':       '#F0FDFF',
      '--surface':  '#FFFFFF',
      '--surface2': '#E8FFFE',
      '--border':   '#CFFAFE',
      '--border2':  '#A5F3FC',
      '--text':     '#083344',
      '--text2':    '#155E75',
      '--text3':    '#4B9EAD',
      '--sidebar-from': '#083344',
      '--sidebar-to':   '#042030',
      '--login-from':   '#ECFEFF',
      '--login-mid':    '#CFFAFE',
      '--login-to':     '#F0FDFF',
    },
  },
  {
    id: 'sage',
    name: 'Sage',
    description: 'Natural greens with earthy warmth',
    preview: '#4ADE80',
    vars: {
      '--p':        '#4ADE80',
      '--p2':       '#22C55E',
      '--pink':     '#86EFAC',
      '--p-light':  '#F0FDF4',
      '--p-mid':    '#DCFCE7',
      '--p-dark':   '#15803D',
      '--bg':       '#F7FDF9',
      '--surface':  '#FFFFFF',
      '--surface2': '#F0FDF4',
      '--border':   '#DCFCE7',
      '--border2':  '#BBF7D0',
      '--text':     '#052E16',
      '--text2':    '#166534',
      '--text3':    '#4AAA6C',
      '--sidebar-from': '#052E16',
      '--sidebar-to':   '#021A0C',
      '--login-from':   '#F0FDF4',
      '--login-mid':    '#DCFCE7',
      '--login-to':     '#F7FDF9',
    },
  },
  {
    id: 'sunset',
    name: 'Sunset',
    description: 'Warm amber and orange gradients',
    preview: '#FB923C',
    vars: {
      '--p':        '#FB923C',
      '--p2':       '#F97316',
      '--pink':     '#FCA5A5',
      '--p-light':  '#FFF7ED',
      '--p-mid':    '#FED7AA',
      '--p-dark':   '#C2410C',
      '--bg':       '#FFFAF5',
      '--surface':  '#FFFFFF',
      '--surface2': '#FFF7ED',
      '--border':   '#FED7AA',
      '--border2':  '#FDBA74',
      '--text':     '#431407',
      '--text2':    '#9A3412',
      '--text3':    '#C4703A',
      '--sidebar-from': '#431407',
      '--sidebar-to':   '#280B03',
      '--login-from':   '#FFF7ED',
      '--login-mid':    '#FED7AA',
      '--login-to':     '#FFFAF5',
    },
  },
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Cool indigo blues for late night sessions',
    preview: '#818CF8',
    vars: {
      '--p':        '#818CF8',
      '--p2':       '#6366F1',
      '--pink':     '#A5B4FC',
      '--p-light':  '#EEF2FF',
      '--p-mid':    '#E0E7FF',
      '--p-dark':   '#4338CA',
      '--bg':       '#F5F5FF',
      '--surface':  '#FFFFFF',
      '--surface2': '#EEF2FF',
      '--border':   '#E0E7FF',
      '--border2':  '#C7D2FE',
      '--text':     '#1E1B4B',
      '--text2':    '#3730A3',
      '--text3':    '#6B72C4',
      '--sidebar-from': '#1E1B4B',
      '--sidebar-to':   '#12112E',
      '--login-from':   '#EEF2FF',
      '--login-mid':    '#E0E7FF',
      '--login-to':     '#F5F5FF',
    },
  },
];

export function applyTheme(themeId) {
  const theme = THEMES.find(t => t.id === themeId) || THEMES[0];
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  updateFavicon(theme.vars['--p'], theme.vars['--p2']);
}

function updateFavicon(color1, color2) {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
    <defs>
      <linearGradient id='g' x1='0' y1='0' x2='64' y2='64' gradientUnits='userSpaceOnUse'>
        <stop offset='0%' stop-color='${color1}'/>
        <stop offset='100%' stop-color='${color2}'/>
      </linearGradient>
    </defs>
    <rect width='64' height='64' rx='14' fill='url(%23g)'/>
    <g transform='translate(32,32)' fill='none' stroke='white' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'>
      <polygon points='-17,2 -17,19 17,19 17,2' fill='rgba(255,255,255,0.2)' stroke='white'/>
      <polyline points='-17,2 -7,-6 7,-6 17,2'/>
      <line x1='0' y1='-6' x2='0' y2='2'/>
      <rect x='-15' y='-18' width='11' height='8' rx='2' fill='rgba(255,255,255,0.15)' stroke='white'/>
      <circle cx='-9.5' cy='-14' r='2.5' fill='rgba(255,255,255,0.2)' stroke='white'/>
      <line x1='0' y1='-19' x2='0' y2='-6'/>
      <polygon points='0,-23 -3,-19 3,-19' fill='white' stroke='white' stroke-width='1'/>
      <rect x='6' y='-18' width='8' height='11' rx='4' fill='rgba(255,255,255,0.15)' stroke='white'/>
      <path d='M4,-8 Q4,-2 10,-2 Q16,-2 16,-8'/>
      <line x1='10' y1='-2' x2='10' y2='2'/>
      <path d='M-4,-26 L-2.8,-22.5 L0,-21.5 L-2.8,-20.5 L-4,-17 L-5.2,-20.5 L-8,-21.5 L-5.2,-22.5 Z' fill='white' stroke='none'/>
      <path d='M0,6 L2,11 L7,11 L3,14 L4.5,19 L0,16 L-4.5,19 L-3,14 L-7,11 L-2,11 Z' fill='rgba(255,255,255,0.6)' stroke='none'/>
    </g>
  </svg>`;
  const encoded = 'data:image/svg+xml,' + svg.replace(/"/g, "'");
  let link = document.querySelector("link[rel=\'icon\']");
  if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
  link.type = 'image/svg+xml';
  link.href = encoded;
}

export function getTheme(themeId) {
  return THEMES.find(t => t.id === themeId) || THEMES[0];
}

// ── HOW TO USE GUIDE ──────────────────────────────────────────────────────────
export const HOW_TO_USE = [
  {
    id: 'collabs',
    icon: '🤝',
    title: 'Managing Collabs',
    subtitle: 'Track every brand deal from first contact to payment',
    steps: [
      {
        title: 'Add a new collab',
        desc: 'Click the + Add collab button in the top right. Fill in the brand name, deal type (paid, barter, UGC), and value. Everything else is optional but the more you fill in, the more powerful it gets.',
      },
      {
        title: 'Move through stages',
        desc: 'Each collab has 11 stages from "In talks" to "Paid / Done". Click any stage dot or pill to jump to that stage. The progress bar updates automatically.',
      },
      {
        title: 'Set priority',
        desc: 'Mark collabs as Urgent, High, Normal or Low. If a brand deadline or due date passes, the priority auto-escalates to Urgent and shows a red flag.',
      },
      {
        title: 'Track deliverables',
        desc: 'Add each piece of content you need to create — reels, stories, posts. Mark pre-shoot requirements separately so you know what to prepare before the shoot day.',
      },
      {
        title: 'Share with the brand',
        desc: 'Every collab has a public share link. Copy it and send to the brand so they can see progress, deliverables and shoot details — no login needed on their end.',
      },
    ],
  },
  {
    id: 'calendar',
    icon: '📅',
    title: 'Calendar',
    subtitle: 'Never miss a shoot, due date or go-live',
    steps: [
      {
        title: 'What shows up automatically',
        desc: 'The calendar pulls shoot appointments, content due dates, go-live dates and approval deadlines from all your collabs. No manual entry needed — just fill in dates when adding a collab.',
      },
      {
        title: 'Sort your view',
        desc: 'Sort events by date (default), priority or brand name using the dropdown in the top right.',
      },
      {
        title: 'Mark events as done',
        desc: 'Each event has a "Mark done" button. Clicking it advances the collab to the right stage automatically — shoot done moves to Editing, content due moves to Delivered, and so on.',
      },
      {
        title: 'Show completed events',
        desc: 'Completed events are hidden by default to keep things clean. Toggle "Show completed" to see everything including past events.',
      },
    ],
  },
  {
    id: 'invoices',
    icon: '🧾',
    title: 'Invoicing',
    subtitle: 'Professional invoices in seconds',
    steps: [
      {
        title: 'Set up your rates first',
        desc: 'Go to My Profile and fill in your standard rates (Reel, Story, TikTok etc). These will pre-fill every new invoice so you\'re not typing the same numbers each time.',
      },
      {
        title: 'Create an invoice',
        desc: 'Click New Invoice, choose single payment or milestone payments. Invoice numbers are auto-generated. Fill in the brand name and your line items.',
      },
      {
        title: 'Milestone payments',
        desc: 'For bigger deals, use milestone payments — add as many milestones as you need (e.g. 50% upfront, 50% on delivery). Mark each one as paid as money comes in.',
      },
      {
        title: 'Download as PDF',
        desc: 'Click the PDF button on any invoice. It opens a print-ready page with your details, bank info and a clean layout — ready to send to the brand.',
      },
      {
        title: 'Add your bank details',
        desc: 'Go to My Profile → Invoice details to save your BSB, account number and ABN. These appear automatically on every PDF.',
      },
    ],
  },
  {
    id: 'links',
    icon: '🔗',
    title: 'My Links Page',
    subtitle: 'Your personalised brand code page',
    steps: [
      {
        title: 'Your public URL',
        desc: 'You get a personal links page at /your-handle/links. Share this in your Instagram bio so followers can find all your brand codes and affiliate links in one place.',
      },
      {
        title: 'Add a product',
        desc: 'Go to My Links in the sidebar. Click Add item — fill in the brand name, product, category, coupon code and shop URL. Upload a logo if you have one.',
      },
      {
        title: 'Category filters',
        desc: 'Each product gets a category tag (Skincare, Supplement, Nails etc). Your followers can filter by category to find what they\'re looking for quickly.',
      },
      {
        title: 'Promo banners',
        desc: 'Running a special campaign or giveaway? Add a promo banner to any product card — give it a title, description and dates. It shows as a highlighted banner on the public page.',
      },
      {
        title: 'Coupon copy button',
        desc: 'Every code has a one-tap copy button. When a follower taps it, the code is copied to their clipboard instantly — no typing needed.',
      },
    ],
  },
  {
    id: 'campaigns',
    icon: '📊',
    title: 'Campaigns',
    subtitle: 'Group collabs from the same brand together',
    steps: [
      {
        title: 'What is a campaign?',
        desc: 'A campaign is a group of collabs tied to the same brand or project — for example, a brand might have you do a Reel, 3 Stories and a TikTok. Link them all under one campaign.',
      },
      {
        title: 'Create a campaign',
        desc: 'Click New Campaign, give it a name, then tick which collabs to include. You\'ll see the combined value, total progress and overall stage at a glance.',
      },
    ],
  },
  {
    id: 'profile',
    icon: '👤',
    title: 'My Profile',
    subtitle: 'Set up your creator profile and invoice details',
    steps: [
      {
        title: 'Profile photo',
        desc: 'Upload a profile photo — it shows on your public links page. Click the circle next to your name, pick a photo, and save. It\'s compressed automatically.',
      },
      {
        title: 'Invoice details',
        desc: 'Fill in your full name, ABN, address and bank details. These appear on every invoice PDF you generate — do this once and you\'re set.',
      },
      {
        title: 'My rates',
        desc: 'Set your standard rates for each content type. When you create a new invoice, these pre-fill as line items so you\'re not entering them from scratch each time.',
      },
    ],
  },
];
